export const emptyAscii = '0x0000000000000000000000000000000000000000000000000000000000000000'

export const maxUni256 = '0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF'

export const dividendWeight = '200%'

export const tip = {
    '0': 'Success',
    '1': 'Prasale Ends'
}